import React, { useEffect, useState, useCallback } from "react";
import NewCustomModal from "../../../../../../../../custom_utilities/Modal/CustomModal";
import { fetchStorePackageView } from "../../../package_details_component/package_overview/StoreComponents/StoreUtils/StoreApiUtils";
import {
  filterValidVariantOptions,
  isPackageSubscribed,
} from "../../../package_details_component/package_overview/StoreComponents/StoreUtils/storePackageUtils";
import "./VarientCard.scss";

const VarientCard = ({
  show,
  onHide,
  packageId,
  finishLoading,
  history,
}) => {
  const [variantOptions, setVariantOptions] = useState([]);
  const [modalTitle, setModalTitle] = useState("");
  const [isLoadingVariants, setIsLoadingVariants] = useState(false);

  const fetchPackageData = useCallback(async (parentPackageId) => {
    setIsLoadingVariants(true);
    setVariantOptions([]);

    try {
      const data = await fetchStorePackageView(parentPackageId);
      const validOptions = filterValidVariantOptions(
        data?.package_quick_variants?.quick_variants_selection_options ?? [],
        parentPackageId
      );

      setVariantOptions(validOptions);
      setModalTitle(
        data?.PackageInstallmentDetails?.package_name || "Select Package"
      );
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingVariants(false);
    }
  }, []);

  useEffect(() => {
    if (packageId && show) {
      fetchPackageData(packageId);
      return;
    }

    setVariantOptions([]);
    setModalTitle("");
  }, [packageId, show, fetchPackageData]);

  const handleClickBuynow = (variant) => {
    finishLoading?.();
    onHide?.();
    history.push(`/package/${variant?.package_id}`);
  };

  return (
    <NewCustomModal
      isOpen={show}
      closeModal={onHide}
      title={modalTitle}
      size="medium"
      hideXIcon={false}
      width="650px"
      height="auto"
      overlayClassName="variant-package-modal-overlay"
      contentClassName="variant-package-modal-content"
      closeButtonClassName="variant-package-modal-close"
    >
      <div className="variant-list">
        {isLoadingVariants ? (
          <p className="variant-list__loading">Loading packages...</p>
        ) : null}

        {!isLoadingVariants && !variantOptions.length ? (
          <p className="variant-list__loading">No packages available.</p>
        ) : null}

        {variantOptions.map((variant) => {
          const purchased = isPackageSubscribed(variant);

          return (
            <div className="variant-card" key={variant.package_id}>
              <div className="variant-content">
                <div className="variant-info">
                  <h6 className="variant-title">
                    {variant.package_name || variant.title}
                  </h6>
                </div>

                <div className="variant-price">{variant.price}</div>
              </div>
              <div className="validity-text" style={{ textAlign: "left" }}>
                {variant.duration}
              </div>
              <div className="variant-actions">
                {purchased ? (
                  <button
                    className="view-details-btn"
                    onClick={() => handleClickBuynow(variant)}
                  >
                    View details
                  </button>
                ) : (
                  <button
                    className="buy-btn"
                    onClick={() => handleClickBuynow(variant)}
                  >
                    Buy Now
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </NewCustomModal>
  );
};

export default VarientCard;
